import { type ApolloClient, type NormalizedCacheObject } from '@apollo/client'
import { GetModalStateDocument } from '@kijiji/generated/graphql-types'

import { type MODAL_REGISTRY } from '@/features/modal/constants/modalRegistry'

export const closeModal = (
  apolloClientCache: ApolloClient<NormalizedCacheObject>['cache'],
  modalId: MODAL_REGISTRY
) => {
  apolloClientCache.writeQuery({
    query: GetModalStateDocument,
    variables: { id: modalId },
    data: { modal: { __typename: 'ModalState', id: modalId, isOpen: false } },
  })
}
